const initialState = {
  user: {},
  changePasswordModalActive: false,
  changePasswordFormState: {
    data: {},
  },
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case 'SET_MY_ACCOUNT': {
      const { user } = payload;
      return {
        ...state,
        user,
      };
    }
    case 'TOGGLE_PASSWORD_CHANGE_MODAL': {
      const { active } = payload;
      return {
        ...state,
        changePasswordModalActive: active,
        changePasswordFormState: initialState.changePasswordFormState,
      };
    }
    case 'ON_CHANGE_PASSWORD_FORM_UPDATE': {
      const { formState } = payload;
      return {
        ...state,
        changePasswordFormState: formState,
      };
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/MyAccount/MyAccount.reducer.js